import { images } from "../../assets/assets";

const SocialHandle = () => {
  return (
    <div className="bg-[#F8FAFF] py-10 md:py-12">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-4 max-w-[1250px] mx-auto px-4">
        {/* Facebook */}
        <div>
          <div className="flex justify-center gap-2 mb-6 md:mb-8">
            <img
              src={images.FaceBook}
              alt="facebook"
              className="w-[28px] h-[28px] md:w-[32px] md:h-[32px]"
            />
            <p className="text-[#1F2933] text-[16px] md:text-[20px] font-medium font-poppins">
              LATEST ON FACEBOOK
            </p>
          </div>
          <div className="p-[6px] md:p-[8px] bg-gradient-to-b from-[#5297FF] to-[#FFB230] max-w-[450px] h-[420px] md:h-[500px] mx-auto rounded-[16px] md:rounded-[20px] overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <iframe
              className="w-full h-full"
              src="https://www.facebook.com/plugins/page.php?href=https://www.facebook.com/devrishihospital&tabs=timeline&width=450&height=500&adapt_container_width=true"
              style={{
                border: "none",
                overflow: "hidden",
                width: "100%",
                height: "100%",
                borderRadius: "14px",
              }}
              scrolling="no"
              frameBorder="0"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              allowFullScreen
              loading="lazy"
              title="Facebook Page"
            />
          </div>
        </div>

        {/* Instagram */}
        <div>
          <div className="flex justify-center gap-2 mb-6 md:mb-8">
            <img
              src={images.Instagram}
              alt="instagram"
              className="w-[28px] h-[28px] md:w-[32px] md:h-[32px]"
            />
            <p className="text-[#1F2933] text-[16px] md:text-[20px] font-medium font-poppins">
              LATEST ON INSTAGRAM
            </p>
          </div>
          <div className="p-[6px] md:p-[8px] bg-gradient-to-b from-[#5297FF] to-[#FFB230] max-w-[450px] h-[420px] md:h-[500px] mx-auto rounded-[16px] md:rounded-[20px] overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <iframe
              className="w-full h-full"
              src="https://www.instagram.com/devrishi_hospital/embed"
              style={{
                border: "none",
                overflow: "hidden",
                width: "100%",
                height: "100%",
                borderRadius: "14px",
              }}
              scrolling="no"
              frameBorder="0"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              allowFullScreen
              loading="lazy"
              title="Instagram Page"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialHandle;